/** Our screen share has its own attendee id but is still us. */
export function isRemoteAttendee(attendeeId: string, ownAttendeeId: string | undefined): boolean {
  return attendeeId.split("#")[0] !== ownAttendeeId;
}

/** Presence survives camera-off joins; the latch preserves a later manual minimise. */
export function shouldExpandForPresence(
  attendeeId: string,
  present: boolean,
  ownAttendeeId: string | undefined,
  alreadyExpanded: boolean,
): boolean {
  return present && isRemoteAttendee(attendeeId, ownAttendeeId) && !alreadyExpanded;
}

/** A share has presence too, but its content tile already represents it. */
export function isContentAttendee(attendeeId: string): boolean {
  return attendeeId.split("#").includes("content");
}
